<section>
  <!-- FALTAN AGREGAR CAMPOS AL FORMULARIO -->
  <div class="form-register">
    <form [formGroup]="formCostAdjustmentDetail">
      <div class="row p-1">
        <div class="col-lg-3 col-md-6 col-sm-6 col-12">
          <app-custom-input-text [labelText]="'Artículo'" [value]="codeNameArticle" [required]="true"
            [disabled]="true"></app-custom-input-text>
        </div>
        <div class="col-lg-1 col-md-2 col-sm-3 col-6">
          <app-custom-input-decimal formControlName="quantity" [labelText]="'Cantidad'"></app-custom-input-decimal>
        </div>
        <div class="col-lg-1 col-md-2 col-sm-3 col-6">
          <app-custom-input-decimal formControlName="adjustedUnitCost" [labelText]="'Vr.Aju.Cto.Unit'"
            (onChangeNumber)="calculateValues($event)"></app-custom-input-decimal>
        </div>
        <div class="col-lg-1 col-md-2 col-sm-3 col-6">
          <app-custom-input-decimal formControlName="totalValue"
            [labelText]="'Vr.Tot.Ajuste'"></app-custom-input-decimal>
        </div>
        <div class="col-lg-3 col-md-4 col-sm-12 col-12 d-flex mt-2">
          <div class="d-flex align-items-end gap-1">
            <app-custom-button [label]="'Guardar'" [severity]="'primary'" (onClick)="send()"></app-custom-button>
            <app-custom-button [label]="'Cancelar'" [severity]="'danger'" (onClick)="clearForm()"></app-custom-button>
          </div>
        </div>
      </div>
    </form>
  </div>
</section>